import { type ReactNode } from 'react';
import { cn } from '@/lib/utils';

type PageContainerWidth = 'narrow' | 'form' | 'wide' | 'full';

const WIDTH_CLASS_NAME: Record<PageContainerWidth, string> = {
  narrow: 'max-w-2xl',
  form: 'max-w-5xl',
  wide: 'max-w-7xl',
  full: 'max-w-none',
};

interface PageContainerProps {
  children: ReactNode;
  footer?: ReactNode;
  width?: PageContainerWidth;
}

export function PageContainer({ children, footer, width = 'form' }: PageContainerProps) {
  const maxWidthClassName = WIDTH_CLASS_NAME[width];
  return (
    <div className="flex flex-col min-h-full">
      <div className="flex-1 p-6 md:p-8">
        <div className={cn('mx-auto w-full', maxWidthClassName)}>{children}</div>
      </div>
      {footer === undefined ? null : (
        <div className="sticky bottom-0 z-10 bg-zoowhite border-t border-zooborder px-6 md:px-8 py-3 lg:py-4">
          <div className={cn('mx-auto w-full', maxWidthClassName)}>{footer}</div>
        </div>
      )}
    </div>
  );
}
